module.exports = __webpack_public_path__ + "static/media/questionoftheday-header.3f1faba4.svg";